//@ts-check
/// <reference path="../../../state/rdms/types.js" />
import React from "react";
import Collapse from "../collapse";
import { Title } from "../components/title";
import { Card, ContentCard, GridLayer, Iteration } from "./styles";
import { DropOptions } from "../components/dropOptions";
import { useUserPanel } from "../viewModel/useUserPanel";

/**
 * @param {{
 *  handleCollapse: (id: string) => void,
 *  collapses: Object<string, boolean>,
 *  data: Rdm | null,
 *  options: { label: string, onClick: () => void, show: boolean }[],
 *  onOpenAddModal: () => void,
 *  userPermissions: {
 *    canEdit: boolean,
 *    canDelete: boolean,
 *    canAdd: boolean
 * },
 *  }} props
 * @return {JSX.Element}
 */
export function UsersCard({
  handleCollapse,
  collapses,
  data,
  options,
  onOpenAddModal,
  userPermissions,
}) {
  const { visibleOptions, remapUsers, getPercentPositives } = useUserPanel({
    options,
    data,
  });

  return (
    <Card id="users-card">
      <ContentCard>
        <Title
          handleCollapse={() => handleCollapse("users-card")}
          collapses={collapses["users-card"]}
          title={`Usuários do RDM (${data?.rdmUsers.length})`}
          onAddClick={onOpenAddModal}
          userPermissions={userPermissions}
        />
        <Collapse isOpened={collapses["users-card"]}>
          <Iteration>
            {!data?.rdmUsers || data.rdmUsers.length === 0 ? (
              <div style={{ padding: "2rem", textAlign: "center" }}>
                Não existe usuário cadastrado,{" "}
                {userPermissions.canAdd ? (
                  <>
                    <span
                      style={{
                        color: "#118052",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                      onClick={onOpenAddModal}
                    >
                      clique aqui
                    </span>{" "}
                    para adicionar.
                  </>
                ) : (
                  <span>contate um administrador para adicionar.</span>
                )}
              </div>
            ) : (
              remapUsers.map((user, idx) => (
                <React.Fragment key={user._id}>
                  <GridLayer gradientColor={user.color} columns={5}>
                    <div className="column-item">
                      <span className="column-title">Usuário</span>
                      <div className="column-content">
                        <img
                          className="column-content"
                          src={user.userData.avatarURL}
                          alt="avatar"
                        />
                        <span>{user.userData.username}</span>
                      </div>
                    </div>

                    <div className="column-item">
                      <span className="column-title">(%) Efetividade</span>
                      <span className="column-content percents">
                        {getPercentPositives(user).toFixed(2)} %
                      </span>
                    </div>
                    <div className="column-item">
                      <span className="column-title">Positivos</span>
                      <span className="column-content positive">
                        {user.positives} (+)
                      </span>
                    </div>
                    <div className="column-item">
                      <span className="column-title">Negativos</span>
                      <span className="column-content negative">
                        {user.negatives} (-)
                      </span>
                    </div>
                    <div className="column-item">
                      <span className="column-title">Ações</span>
                      <span className="column-content">
                        {visibleOptions && (
                          <DropOptions data={user} options={visibleOptions} />
                        )}
                      </span>
                    </div>
                    <div className="column-item">
                      <span className="column-title">Rank</span>
                      <span className="column-content rank">
                        {user.userData.rank.toUpperCase()}
                      </span>
                    </div>
                    <div className="column-item rdm-description">
                      <span className="column-title">Notas</span>
                      <p className="column-content ">{user.description}</p>
                    </div>
                  </GridLayer>
                  {idx < data.rdmUsers.length - 1 && (
                    <div className="divisor-line" />
                  )}
                </React.Fragment>
              ))
            )}
          </Iteration>
        </Collapse>
      </ContentCard>
    </Card>
  );
}
